/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { RichTextQuillComponentDisplay } from "cms/components/components/rich-text-editor-quill/display";
import { getComponentZoneLayout } from "cms/components/components/component";
import { RichTextTipTapComponentDisplay } from "cms/components/components/rich-text-editor-tiptap/display";
import { RichTextTipTapComponentEditor } from "cms/components/components/rich-text-editor-tiptap/edit";

const RichTextEditorTipTapComponent = (props) => {
    
    // const ops = get(props, 'component.richtext.ops')
    const { component } = props;
    const { richtext } = component || {};
    const { ops } = richtext || {};
    const isQuill = !!ops;
    const zoneProps = {
        ...props,
        displayComponent: isQuill
            ? <RichTextQuillComponentDisplay />
            : <RichTextTipTapComponentDisplay />,
        editComponent: <RichTextTipTapComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

RichTextEditorTipTapComponent.displayName = "RichTextEditorTipTapComponent";
export { RichTextEditorTipTapComponent };
